import { AVERAGE_HOURS_IN_MONTH } from '@cast/constants';

import type { CostReportClusterSummaryNormalized } from '@cast/shared-cost-data-access';

export const getMonthlyCostFromSummary = (
  summary?: CostReportClusterSummaryNormalized
): number | null => {
  if (!summary) {
    return null;
  }

  const hourlyOnDemand = summary.costHourlyOnDemand?.toNumber() ?? 0;
  const hourlySpot = summary.costHourlySpot?.toNumber() ?? 0;
  const hourlyFallback = summary.costHourlySpotFallback?.toNumber() ?? 0;
  const hourlyTotal = hourlyOnDemand + hourlySpot + hourlyFallback;

  if (!hourlyTotal) {
    return null;
  }

  return hourlyTotal * AVERAGE_HOURS_IN_MONTH;
};
